import { API_URLS } from '../../../configs/constants/urls.js';
import { appendXsrfToken, onError } from '../../../helpers/request/utils.js';
import { createPostRequest } from '../../../helpers/request/request.js';
import TokenService from '../../../helpers/request/tokens.js';
export const sendVerifyAccountExistsRequest = async ({ email, }) => {
    try {
        if ((await TokenService.getCsrfToken()) !== true) {
            return onError();
        }
        const requestOptions = appendXsrfToken({});
        const response = await createPostRequest(API_URLS.BFF.VERIFY_ACCOUNT_EXISTS, {
            email,
        }, requestOptions);
        return response.data;
    }
    catch (error) {
        console.error('VerifyAccount Failed: ', error);
    }
};
//# sourceMappingURL=verifyAccountExists.js.map